import { Injectable, inject } from "@angular/core";

import { NavigationService } from "@tylertech/core-module";
import { AggregateHelperService, IAggregateActionHandler } from "@tylertech/aggregates-module";
import { IAggregate, ICardData, ICardAction, ExecutionResult } from "@tylertech/tyler-api-types";

import { UBDashboardService } from "../services/ubdashboard.service";
import { CommonDialogsService } from "@tylertech/common-dialogs-module";

@Injectable()
export class PendingPaymentPlanActionHandler implements IAggregateActionHandler
{
    private readonly $navigationService = inject(NavigationService);
    private readonly $commonDialogsService = inject(CommonDialogsService);
    private readonly $aggregateHelperService = inject(AggregateHelperService);
    private readonly $ubDashboardService = inject(UBDashboardService);


    predicate(aggregate: IAggregate, _cardData: ICardData, _action: ICardAction): boolean
    {
        return aggregate.AggregateProviderId === "Utility.PendingPaymentPlan";
    }

    execute(_aggregate: IAggregate, cardData: ICardData, action: ICardAction): Promise<boolean>
    {
        const self = this;
        if (action.Id === "PayPendingPaymentPlan")
        {
            const paymentPlanId = this.$aggregateHelperService.getFieldValue(cardData, "Id");

            this.$ubDashboardService.getPathToPayPaymentPlan(paymentPlanId)
                .then(
                    (result: string) =>
                    {
                        // open receipting in a new tab
                        return self.$navigationService.openApp("form", "_blank", { "path": result });
                    },
                    _error =>
                    {
                        return this.handleError()
                            .then(() => window.location.reload());
                    });
        }
        return Promise.resolve(true);
    }

    load(_aggregate: IAggregate, _cardData: ICardData, _action: ICardAction): void
    {
        /* NO_OP */
    }

    private HandleResult(executionResult: ExecutionResult<string>): Promise<void>
    {
        const lineBreak = "<br />";

        if (executionResult.Success)
        {
            const htmlErrorResult = executionResult.Result.replace(/\r?\n|\r/g, lineBreak);
            return this.$commonDialogsService.showAlertHtmlMessage(
                executionResult.Result
                    ? htmlErrorResult
                    : "",
                "Successful");
        }

        const htmlErrorMessage = executionResult.ErrorMessage.replace(/\r?\n|\r/g, lineBreak);
        return this.$commonDialogsService.showAlertHtmlMessage(htmlErrorMessage, "Error");
    }

    private handleError(): Promise<void>
    {
        return this.$commonDialogsService.showAlertHtmlMessage(
            "Check ERP PR0 10 dispatch logs for more information.",
            "Unable to process command");
    }
}
